<script>

	import Modal from '../$components/modal.container.svelte'

	import Invoices from './component.invoices.svelte'
	import CreateInvoiceFree from './component.create.invoice.free.svelte'

	export let all = false

</script>

<Invoices { all } />

<Modal id="invoice_create_free_modal" title="Crear factura" >
    <CreateInvoiceFree />
</Modal>